const apiUrl = process.env.REACT_APP_API_URL;
export const PostJutgeActivitatIdProblema = async (id_activitat: string, json: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/activitats/${id_activitat}/problema`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(json)
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
